import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { formikValidation, formikinitialvalues } from "../../../CommonFunction/common";
import Button from "../../Components/Button/Button";
import Input from "../../Components/Input/Input";

const BookingPageInputs = ({ inputfields, Type, fielddata, TypeOfPortal }) => {
  const [fields, setfields] = useState(inputfields);
  const [alldata, setalldata] = useState<any>({});
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: "Add_FormFieldData",
      payload: { data: alldata, key: Type },
    });
  }, [alldata]);

  useEffect(() => {
    if (fielddata) {
      let arr: any = [];
      for (var a = 0; a < fields.length; a++) {
        arr.push({ [fields[a].name]: fielddata[fields[a].name] });
        formik.setFieldValue(fields[a].name, fielddata[fields[a].name]);
      }
      let obj = {};

      for (var l = 0; l < arr.length; l++) {
        let temp = arr[l];
        for (var key in temp) {
          obj[key] = temp[key];
        }
      }
      if (obj) {
        setalldata(obj);
      }
    }
  }, [fielddata]);

  let handleTrackLink = (Link) => {
    window.open(Link, "_blank");
  };

  // useEffect(() => {
  //   dispatch({
  //     type: "Add_FormFieldData",
  //     payload: { data: alldata, key: Type },
  //   });
  // }, [alldata]);

  const validate = (values: any) => {
    setalldata({ ...alldata, ...values });
  };

  const formik = useFormik({
    initialValues: () => {
      let initialstate = formikinitialvalues(fields);
      return initialstate;
    },
    validationSchema: formikValidation(fields),
    validate,
    onSubmit: (values) => { },
  });

  return (
    <div className="Addloadsection2">
      {/* <div className="headingaddloadsection2">{replaceUnderscore(Type)}</div> */}
      {fields.length > 0 && (
        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <div className="contentAddload2">
            {fields?.map((e) => {
              if (e.name === "Sim_Tracking_Link") {
                return (
                  <div key={e.id} style={{ display: "flex", alignItems: "center" }}>
                    <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig={e}
                      JurnalDropdown=""
                      Section_Type=""
                      disabled=""


                      transactions=""
                      PaymentProcess=""
                      TypeOfPortal={TypeOfPortal}
                      name={e.name}
                      value={alldata[e.name] || formik.values[e.name] || ""}
                      label={e.label}
                      className={"inputwidthAddload"}
                      type={e.type}
                      modalform={true}
                      handleInputChange={(evt) => {
                        formik.handleChange(evt);
                      }}
                      // handelformikdata={handelformikdata}
                      dropdowndata={e.dropdowncontent}
                      handleBlur={formik.handleBlur}
                      touched={formik.touched[e.name]}
                      error={formik.errors[e.name]}
                      max={e.max ? e.max : undefined}

                      notSearchable={e.name === "From_City" || e.name === "To_City" ? true : false}
                    />
                    <div style={{ marginTop: "23px", marginLeft: "10px" }}>
                      <Button
                        name="modalbutton"
                        text={"Sim Track"}
                        action={() => handleTrackLink(alldata[e.name])}
                        type={""}
                        children={""}
                        disabled={""}
                      />
                    </div>
                  </div>
                );
              }

              return (
                <div key={e.id}>
                  <Input
                    EMTQuery=""
                    checked={""}
                    InputConfig={e}
                    JurnalDropdown=""
                    Section_Type=""
                    disabled=""


                    transactions=""
                    PaymentProcess=""
                    TypeOfPortal={TypeOfPortal}
                    name={e.name}
                    value={alldata[e.name] || formik.values[e.name] || ""}
                    label={e.label}
                    className={"inputwidthAddload"}
                    type={e.type}
                    modalform={true}
                    handleInputChange={(evt) => {
                      formik.handleChange(evt);
                    }}
                    // handelformikdata={handelformikdata}
                    dropdowndata={e.dropdowncontent}
                    handleBlur={formik.handleBlur}
                    touched={formik.touched[e.name]}
                    error={formik.errors[e.name]}
                    max={e.max ? e.max : undefined}

                    notSearchable={e.name === "From_City" || e.name === "To_City" ? true : false}
                  />
                </div>
              );
            })}
          </div>
        </form>
      )}
    </div>
  );
};

export default BookingPageInputs;
